import React from 'react';

import { Form, Input } from 'antd';
import { ButtonTheme, FormItem } from './ProxyVerifyStyle';

interface Props {
  className?: string,
}

const FormInputContract: React.FC<Props> = ({
  className,
  ...props
}) => {
  const onReadFinish = () => {

  }

  return (
    <Form onFinish={onReadFinish}>
      <FormItem>
        <Input
          style={{border: 'none'}}
          placeholder={`Proxy address`}
        />
      </FormItem>
      <div
        style={{
          display: 'flex',
          gap: '8px'
        }}
      >
        <ButtonTheme theme={{ bg: '#766B60', text: '#fff' }} htmlType="submit" style={{ marginTop: "20px" }}>
          <span style={{ color: '#fff' }}>{`Verify`}</span>
        </ButtonTheme>
        <ButtonTheme htmlType="submit" style={{ marginTop: "20px" }}>
          {`Reset`}
        </ButtonTheme>
      </div>
    </Form>
  );
};

export default FormInputContract;